import { Intent } from "@blueprintjs/core";
import { IconName } from "@blueprintjs/icons";
import { CustomerOrder_Type, CustomerOrder_State } from "../../../api/schema";

export const IconMapperType: { [key in CustomerOrder_Type]: IconName } = {
  inquiry: "inbox",
  part_order: "list",
  repair: "wrench",
};

export const IconMapperTypeIntent: { [key in CustomerOrder_Type]: Intent } = {
  inquiry: "primary",
  part_order: "success",
  repair: "danger",
};

export const IconMapperState: { [key in CustomerOrder_State]: IconName } = {
  accepted: "inbox-update",
  pickedup: "airplane",
  processing: "cog",
  ready_for_pickup: "compressed",
  wait_for_parts: "outdated",
  wait_for_reply: "outdated",
  canceled: "cross",
};

export const IconMapperStateIntent: { [key in CustomerOrder_State]: Intent } = {
  accepted: "none",
  pickedup: "success",
  processing: "primary",
  ready_for_pickup: "success",
  wait_for_parts: "warning",
  wait_for_reply: "warning",
  canceled: "danger",
};
